import lodash from 'lodash'

export default {
  emits: ['update:modelValue'],

  props: {
    modelValue: [String, Number],

    label: {
      type: String,
    },

    name: {
      type: String,
    },

    errors: {
      type: Object,
      default: {},
    },
  },

  computed: {
    displayLabel() {
      return this.label || lodash.startCase(this.name)
    },

    error() {
      return this.errors[this.name]
    },
  },
}
